import { Controller } from "@hotwired/stimulus"

// Repeatable nested-attribute rows from a <template>: `add` appends a copy with the template's
// NEW_RECORD index replaced by a unique one; `remove` drops a row not saved yet
// (operator/events/_ticket_type_fields).
export default class extends Controller {
  static targets = ["list", "template"]

  add(event) {
    event.preventDefault()
    const html = this.templateTarget.innerHTML.replaceAll("NEW_RECORD", Date.now().toString())
    this.listTarget.insertAdjacentHTML("beforeend", html)
    this.listTarget.lastElementChild?.querySelector("input:not([type=hidden])")?.focus()
  }

  remove(event) {
    event.preventDefault()
    event.target.closest("[data-nested-row]")?.remove()
  }
}
